<template>
  <span>
  <!-- Page Heading -->
          <div class="d-sm-flex align-items-center justify-content-between mb-4" style="visibility:hidden">
            <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
            <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
              <i class="fas fa-download fa-sm text-white-50"></i> Generate Report</a>
          </div>

          <div class="row">
            <div class="col-12">
              <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link active" id="pills-home-tab" data-toggle="pill"
                   href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Create Category</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="pills-profile-tab" data-toggle="pill" 
                  href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Created Categories</a>
                </li>
              </ul>
            </div>
            <!-- form area -->
            <div class="col-12">
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                      <div class="col-xl-8 col-12">
                        <div class="card shadow mb-4">
                          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Create Category</h6>
                          </div>
                          <!-- Card Body -->
                          <div class="card-body">
                              <form @submit.prevent='addCategory'>
                                      <div class="form-group" >
                                        <label for="category">
                                            <input class="form-control form-control-lg" type="text" name="category"
                                            id="category" v-model="category" required placeholder="Enter Category Name">
                                        </label>
                                      </div>
                                          <p class="text-success">{{success}}</p>
                                      <button class="btn btn-primary">
                                        Create
                                      </button>
                              </form>
                            </div>
                          </div>
                        </div>
                     </div>
                     
                <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div class="col-xl-8">
                        <div class="card shadow mb-4">
                          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">All Categories</h6>
                          </div>
                            <div class="card-body">
                                <div class="col-12 mb-4" v-if="categories.length === 0 && !loading">
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            <p class="p-5">No Category Available</p> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                  <div class="col-12 mb-4" v-if="loading">
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            <p class="">
                                              ...Loading data 
                                              </p> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-12 mb-4" v-if="categories.length > 0">
                                  <div class="card border-left-primary shadow h-100 py-2" v-for='(category, key ) in categories' :key="category.id">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            {{category.name}}
                                          </div>
                                        </div>
                                        <div class="col-auto">
                                          <button class="btn btn-primary btn-sm mr-2" @click="agreements(category.id, category.name)"
                                             type="button"
                                             >view agreements</button>
                                          <button class="btn btn-danger btn-sm"
                                             type="button" data-toggle="modal" data-target="#exampleModal"
                                             @click="confirmDelete(category.id,key)">delete</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                          </div>
                        </div>
            </div>
          </div><!--- end of pills content -->
          <!--- start of delete modal --->
          <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                      Do you Really Want To Delete This Category?
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                    <p v-if="success" class="text">{{success}}</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="deleteCategory">delete</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
          <!--- end of delete modal box --->
        </div>
      </div>
          
  </span>
</template>

<script>
import $ from 'jquery'
$('.toast').toast(500)

export default {
  data() {
    return {
      category:'',
      categoryId: null,
      key:null
    }
  },
  methods: {
    confirmDelete(id, key) {
      this.categoryId = id;
      this.key = key
    },
    agreements(id,name){
      this.$router.push(`/editor_dashboard/${id}/${name}`)
    },
    deleteCategory(){
      this.$store.dispatch('deleteCategory', {id:this.categoryId,key:this.key})
    },
    addCategory(){
      this.$store.dispatch('addCategory',this.category)
      if(this.success) {
        this.category = ''
        this.success = null
      }
    },

  },
  computed:{
      categories() {
        return this.$store.state.editor.categories;
      },
      success(){
        return this.$store.state.editor.success
      },
      loading() {
        return this.$store.state.editor.loading
      }
  },
  created(){
      this.$store.dispatch('getCategories')
  }
}
</script>

<style>

</style>